var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkGreenCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#F2D700",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7787 17.9922L26.0443 24.6387H19.1068L17.3725 17.9922H13.4082H27.7787Z",
    fill: "#367F9A",
    stroke: "#367F9A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9297 28.473C25.4086 28.473 25.7969 28.0725 25.7969 27.5783C25.7969 27.0842 25.4086 26.6836 24.9297 26.6836C24.4508 26.6836 24.0625 27.0842 24.0625 27.5783C24.0625 28.0725 24.4508 28.473 24.9297 28.473Z",
    fill: "#367F9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2217 28.473C20.7006 28.473 21.0889 28.0725 21.0889 27.5783C21.0889 27.0842 20.7006 26.6836 20.2217 26.6836C19.7427 26.6836 19.3545 27.0842 19.3545 27.5783C19.3545 28.0725 19.7427 28.473 20.2217 28.473Z",
    fill: "#367F9A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreenCart);
export default __webpack_public_path__ + "static/media/dark-green-cart.8406b49d01e6d4faa20b15a0a30c3947.svg";
export { ForwardRef as ReactComponent };